import { Suspense } from 'react'

import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { t } from 'i18next'
import { ErrorBoundary } from 'react-error-boundary'
import { useParams } from 'react-router'

import { Skeleton } from '@/components/ui'
import { Page } from '@/layouts/page'
import {
  DetalhesLeadRepresadoContent,
  DetalhesLeadRepresadoContentSkeleton,
} from '@/pages/detalhes-lead-represado/ui/detalhes-lead-represado-content'
import { ApiErrorDisplay } from '@/shared/api-error-display'

export const DetalhesLeadRepresadoPage = () => {
  const { id } = useParams<{ id: string }>()

  const breadcrumb = [
    { label: t('leads-represados:pages.consulta.breadcrumb'), to: '/leads-represados' },
    { label: t('leads-represados:pages.detalhes.breadcrumb') },
  ]

  return (
    <Page
      breadcrumb={breadcrumb}
      className="mx-auto min-h-screen w-full sm:max-w-4xl"
      data-testid="detalhes-lead-represado-page"
    >
      <Page.Main>
        <Page.Header>
          <Page.Title>{t('leads-represados:pages.detalhes.titulo')}</Page.Title>
          <Page.Description>{t('leads-represados:pages.detalhes.descricao')}</Page.Description>
        </Page.Header>
        <Page.Section>
          <QueryErrorResetBoundary>
            {({ reset }) => (
              <ErrorBoundary FallbackComponent={ApiErrorDisplay} onReset={reset}>
                <Suspense fallback={<DetalhesLeadRepresadoContentSkeleton />}>
                  <DetalhesLeadRepresadoContent leadId={id ?? ''} />
                </Suspense>
              </ErrorBoundary>
            )}
          </QueryErrorResetBoundary>
        </Page.Section>
      </Page.Main>
    </Page>
  )
}

export const DetalhesLeadRepresadoPageSkeleton = () => {
  return (
    <div className="mx-auto min-h-screen w-full sm:max-w-4xl" data-testid="detalhes-lead-represado-skeleton">
      <div className="mb-8">
        <Skeleton className="mb-2 h-7 w-64" />
        <Skeleton className="h-4 w-96" />
      </div>
      <div className="border-muted border-1 bg-white px-4 py-6">
        <DetalhesLeadRepresadoContentSkeleton />
      </div>
    </div>
  )
}
